import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import PrivateRoute from "../Authentication/component/PrivateRoute";
import Loader from "../utilis/component/SkeletonLoading/Loader";
import helpRoutelist from "./routelist";

const HelpPage = lazy(() => import("./Help"));

const helpRoute: RouteObject[] = [
  {
    path: `${helpRoutelist.help}`,
    element: (
      <PrivateRoute>
        <Loader>
         <HelpPage/>
        </Loader>
      </PrivateRoute>
    ),
  },
  
];

// export default InsuranceRoute;
export default helpRoute;
